<template>
  <div class="textarea-group" :class="`${inputChanged}`">
    <textarea
      :rows="rows"
      class="textarea-group__textarea"
      :placeholder="placeholder"
      :disabled="disabled"
      v-model="inputValue"
      @focus="$emit('focus')"
      v-scroll-into-view
    >
    </textarea>

    <label
      class="textarea-group__label"
      v-if="label || placeholder">

        {{label ? label : placeholder}}

    </label>
  </div>
</template>

<script>
import emitInputValue from '@/mixins/emitInputValue'
import scrollIntoView from '@/directives/scrollIntoView'

export default {
  name: 'v-textarea',
  mixins: [emitInputValue],
  directives: {
    scrollIntoView
  },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    }
  },
  computed: {
    inputChanged () {
      if (this.inputValue) return 'textarea-group--active'

      return ''
    }
  }
}
</script>

<style lang="scss">
  @mixin inputActive {
    padding: 1.7rem 1rem .7rem 1rem;
  }

  @mixin labelActive {
    opacity: 1;
    visibility: visible;
    font-size: 1.3rem;
    transform: translateY(-.6rem);
  }

  .textarea-group {
    display: flex;
    flex-direction: column;
    position: relative;

    &__label {
      margin-bottom: 1rem;
      position: absolute;
      top: .9rem;
      left: 1.1rem;
      font-size: 1.4rem;
      color: $color-space;
      opacity: 0;
      visibility: hidden;
      transition: all .2s;
    }

    &__textarea {
      border: 1.3px $color-azure solid;
      border-radius: $border-radius;
      padding: 1.2rem 1rem;
      font-family: inherit;
      font-size: inherit;
      font-size: 1.4rem;

      &::placeholder {
        color: $color-space;
        opacity: 1;
        transition: all .2s
      }

      &:focus {
        @include inputActive;
        outline: none;
        border: 1px $color-primary solid;

        &.textarea-group__textarea::placeholder {
          opacity: 0;
        }
      }

      &:disabled {
        color: $color-grey-dark;
        background-color: $color-grey-extra-light;
        cursor: unset;
      }
    }

    &__textarea:focus + .textarea-group__label {
      @include labelActive;
    }

    &--active {
      .textarea-group__label {
        @include labelActive;

      }

      .textarea-group__textarea {
        @include inputActive;

      }
    }
  }
</style>
